export default __webpack_public_path__ + "static/media/deliveries_1.91455100.png";